"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractHeadersFromAxiosResponse = void 0;
function extractHeadersFromAxiosResponse(response) {
    var headers = [];
    for (var _i = 0, _a = Object.keys(response.headers); _i < _a.length; _i++) {
        var headerKey = _a[_i];
        headers.push({
            header: headerKey,
            value: response.headers[headerKey]
        });
    }
    return headers;
}
exports.extractHeadersFromAxiosResponse = extractHeadersFromAxiosResponse;
//# sourceMappingURL=headers-helper.js.map